import type { Prototype } from "../prototype-types";

// Sam Chieng's prototype shard.
export const samChiengPrototypes: Prototype[] = [
  {
    id: "product-tiles",
    name: "Product Tiles",
    path: "/sc/product-tiles",
    description:
      "Product tile variants and explorations for search and discovery surfaces.",
    owner: "Sam Chieng",
    createdAt: "2026-04-01",
    lastUpdated: "2026-07-07",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/8bc9a85d49ca513dcbc6f79b550b1c7efe293b93063d020796ea4b450886c6e0.png",
    creationTool: "cursor",
  },
  {
    id: "multi-turn-search",
    name: "Multi-turn Search",
    path: "/sc/multi-turn-search",
    description:
      "Multi-turn search interaction and UI exploration for retailers.",
    owner: "Sam Chieng",
    createdAt: "2026-03-12",
    lastUpdated: "2026-03-31",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/20c1ae8ebb83b4977d7862b41e6907bd3474b08a79e9ea00f30b981b55e458a8.png",
    creationTool: "cursor",
  },
  {
    id: "search-split-grid-results",
    name: "Search split grid results",
    path: "/sc/search-split-grid-results",
    description:
      "Search results with a split two-column grid layout exploration for retailers.",
    owner: "Sam",
    createdAt: "2026-03-26",
    lastUpdated: "2026-04-02",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/e5f3dc1e14d32f8237e7667d7d5c1061648afa2590feeb401603a901b98a3410.png",
    creationTool: "cursor",
  },
  {
    id: "pdp-mobile",
    name: "PDP",
    path: "/sc/pdp-mobile",
    description:
      "Mobile PDP prototype with product grid, quantity picker, variant selection, and cart functionality.",
    owner: "Sam",
    createdAt: "2026-02-05",
    lastUpdated: "2026-02-05",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/689ad6f84adda0614127a79d8403ea7836b7b178d7036b8090408ebd223a0096.png",
    creationTool: "cursor",
  },
  {
    id: "find-similar",
    name: "Find similar",
    path: "/sc/find-similar",
    description: "Find similar products modal exploration on Search.",
    owner: "Sam",
    createdAt: "2026-01-27",
    lastUpdated: "2026-05-06",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/6bbffbc00043b2c8ad989e9d8e8faefae7f437cd67a851416bc09801a7658b08.png",
    creationTool: "cursor",
  },
  {
    id: "search-refinement",
    name: "Search refinement",
    path: "/sc/search-refinement",
    description: "Thematic queries — narrowing intent through shortcut cards.",
    owner: "Sam",
    createdAt: "2026-01-27",
    lastUpdated: "2026-08-12",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/b2c6886fc9b74d021006fa6c4cdf774290febe5ac166a007ce948f8c8b55706e.png",
    creationTool: "cursor",
  },
  {
    id: "sc-reorder-carousel",
    name: "Reorder carousel",
    path: "/sc/reorder-carousel",
    description: "",
    owner: "Sam Chieng",
    createdAt: "2026-05-06",
    lastUpdated: "2026-05-06",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/f7a300f16f547857191589050701c97cefc4e9e22a047bed8833c552023f87f5.png",
    creationTool: "claude-code",
  },
  {
    id: "sc-reordered-products-typeahead",
    name: "Reordered Products in Typeahead",
    path: "/sc/reordered-products-typeahead",
    description:
      "Show previously-ordered products at the top of the retailer search typeahead.",
    owner: "Sam Chieng",
    createdAt: "2026-05-11",
    lastUpdated: "2026-05-11",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/11de562164ec4ed7bacd5b733b28968c48cf1af3f93152d8091041be3479cd6a.png",
    creationTool: "claude-code",
  },
  {
    id: "sc-filters",
    name: "Filters",
    path: "/sc/filters",
    description: "Filter interaction patterns",
    owner: "Sam Chieng",
    createdAt: "2026-07-29",
    lastUpdated: "2026-07-29",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.faire.com/fastly/3dc8b59db1ecc573b84b2f35984a4e3f0c64d77be99b3ecfa62e1dc7a2800c0a.png",
    creationTool: "claude-code",
  },
  {
    id: "sc-next-gen-search",
    name: "Search Vision 2026",
    path: "/sc/next-gen-search",
    description:
      "Next generation search experience tying together explorations across product tiles, refinement, find similar, and typeahead.",
    owner: "Sam Chieng",
    createdAt: "2026-07-29",
    lastUpdated: "2026-07-29",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/sc-next-gen-search.png",
    creationTool: "claude-code",
  },
  {
    id: "sc-product-tiles-reviews-count",
    name: "Product tiles - reviews count",
    path: "/sc/product-tiles-reviews-count",
    description:
      "Search grid testing a brand ratings count next to the rating, with three type/color treatments for the count.",
    owner: "Sam Chieng",
    createdAt: "2026-08-12",
    lastUpdated: "2026-08-12",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/sc-product-tiles-reviews-count.png",
    creationTool: "claude-code",
  },
  {
    id: "sc-add-to-cart",
    name: "Add to cart",
    path: "/sc/add-to-cart",
    description: "Add to cart interactions on the search results grid.",
    owner: "Sam Chieng",
    createdAt: "2026-09-01",
    lastUpdated: "2026-09-01",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail: "https://cdn.faire.com/fastly/7ed09dc26fcf2868b634875190d4ddb93ccb6f97a104c444d75a1670848d7fa5.png",
  },
  {
    id: "sc-cart-separate-order-mins",
    name: "Cart - separate order mins",
    path: "/sc/cart-separate-order-mins",
    description:
      "Brand cart page with per-brand order minimums, recreated from the live retailer cart.",
    owner: "Sam Chieng",
    createdAt: "2026-10-13",
    lastUpdated: "2026-10-13",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/sc-cart-separate-order-mins.png",
    creationTool: "claude-code",
  },
];
